import { REPORT_TYPE } from "../common/common"

export const AWARD_VIEW_BY_OPTIONS = {
  AWARD_DATE: "award_date_view",
  CALENDAR_YEAR: "calendar_year_view",
  COMPENSATION_YEAR: "comp_year_view",
  CUSTOM: "custom_view",
  OPTION_ACTIVITY: "option_activity_view"
}

export const AWARD_VIEW_TO_REPORT_TYPE = new Map([
  [AWARD_VIEW_BY_OPTIONS.AWARD_DATE, REPORT_TYPE.AWARD_SUMMARY_AWARD_DATE],
  [AWARD_VIEW_BY_OPTIONS.CALENDAR_YEAR, REPORT_TYPE.AWARD_SUMMARY_CALENDAR_YEAR],
  [AWARD_VIEW_BY_OPTIONS.COMPENSATION_YEAR, REPORT_TYPE.AWARD_SUMMARY_COMPENSATION_YEAR],
  [AWARD_VIEW_BY_OPTIONS.CUSTOM, REPORT_TYPE.AWARD_SUMMARY_CUSTOM],
  [AWARD_VIEW_BY_OPTIONS.OPTION_ACTIVITY, REPORT_TYPE.AWARD_SUMMARY_OPTION]
]);

export const AWARD_SUMMARY_OPTIONS = {
  VIEW_BY_PDF: "award_summary_view_by_pdf",
  DOWNLOAD_EXCEL: "award_summary_download_excel"
};

export const DETAILED_TAX_INFORMATION_OPTIONS = {
  VIEW_BY_PDF: "detailed_tax_information_view_by_pdf",
  DOWNLOAD_EXCEL: "detailed_tax_information_download_excel",
  VIEW_STATEMENT: "detailed_tax_information_view_statement"
};

export const VEST_OR_TAX_OPTIONS = {
  VEST_ELECTION: "vest_election",
  TAX_ELECTION: "tax_election",
  US_FED_TAX_RATE: "us_fed_tax_rate"
};


export const AWARD_REGION_CODE = {
  FRA: "FRA"
}

export const AWARD_GRANT_TYPE = {
  ISRRSU: "ISRRSU",
  FRARSU: "FRARSU",
  FRARSUNB: "FRARSUNB",
  FRARSU2NB: "FRARSU2NB",
  FRARSU2: "FRARSU2",
  FRARSU3: "FRARSU3",
  EXCHNG_OLD: "EXCHNG_OLD",
  FRANQ: "FRANQ",
  EXCHNG_NEW: "EXCHNG_NEW",
  NQ: "NQ",
  RSU: "RSU"
}

export const COMPENSATION_YEAR = {
  START_MONTH: 4,
  END_MONTH: 3
}

export const ROW_HEADER_LEFT_MARGIN = 40;
export const ROW_HEADER_TITLE_FONT_WEIGHT = "medium";
export const ROW_HEADER_TITLE_FONT_SIZE = "T200";
export const ROW_HEADER_INFO_FONT_SIZE = "T100";
